<template>
  <span class="def-button-cross">
    <svg class="def-button-cross__icon">
      <use xlink:href="#svg-close"></use>
    </svg>
  </span>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.def-button-cross {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
  &__icon {
    width: 20px;
    height: 20px;
    fill: #3f3f44;
    transition: 0.2s linear fill;
    flex-shrink: 0;
  }
  &:hover {
    .def-button-cross__icon {
      fill: var(--color-red);
    }
  }
}
</style>
